<!-- Runmode:A3/A3O用のコンポーネント -->
<template>
  <div class="a3">
    <PinchInImg v-show="showPinchIn"/>
    <div class="page-content">
      <div class="inner" :class="cssLayoutID">

        <div class="toparea-image">
          <div class="img-wrapper" @touchstart="onTouchStart(currentData.image)"
               @touchend="onTouchEnd()" @touchmove="onTouchEnd()"><img v-if="currentData != null" :src="currentData.image"></div>
        </div>

        <div class="cards-container" :class="templateTypes[0]">
          <div class="card-inner" :class="templateTypes[1]" v-for="index in actGroupIndexList.length" :key="index">
            <div class="item" v-for="item in actGroupIndexList[index -1]" :class="{ complete: questionStatus == 'end' }" :key="item">
              <A3act :act="pathstep.acts[item]" :answer="currentData" :questionState="questionStatus"
                :index="item" :isSelect="isSelect" @isCorrect="childIsCorrect()" @isInCorrect="childIsInCorrect()" @clickImage="clickItem(pathstep.acts[item], item)"
                @onTouchStart="onTouchStart" @onTouchEnd="onTouchEnd"/>
            </div>
          </div>
          <div v-if="isScrollIconVisible" class="icon-scroll" />
        <!-- /.cards-container -->
        </div>

      <!-- /.inner -->
      </div>
    <!-- /.page-content -->
    </div>
  <!-- /.a3_01 -->
  </div>
</template>

<script>
// 共通処理
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";

//コンポーネント
import A3act from "./A3act";
// 画像拡大モーダルコンポーネント
import PinchInImg from "./PinchInImg";

import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// Vuexで状態管理
const store = new Vuex.Store({
  state: {
    questionState: "start"
  },
  mutations: {
    changeQuestionState(state, payload) {
      state.questionState = payload.val;
    }
  }
});

export default {
  name: "A3",
  props: {
    pathstep: Object,
    isScrollIconVisible: Boolean
  },
  mixins: [
    common,
    runmode,
    audio,
    constants
  ],
  data() {
    return {
      // actのindex配列
      items: [],
      // actのグループごとの配列
      actGroupIndexList: [],
      // 出題対象のactData
      currentData: null,
      // 正解済みactのindex配列
      correctIndex: [],
      // 正解／不正解を判断するフラグ（storeコミット用）
      isActState: true,
      // 画像選択可能か否かを判断するフラグ
      isSelect: false,
      // 全問正解時のタイマー
      allCorrectTimer: null,
      // タッチイベント長押しタイマー
      touchTimer: null
    };
  },
  computed: {
    questionStatus: function() {
      return store.state.questionState;
    },
    templateTypes: function() {
      // テンプレートクラス切り替え
      if (this.pathstep.groupNum == 0) {
        switch (this.pathstep.actNum) {
          case 3:
            return ["a3-card3", ""];
          case 4:
            return ["a3-card4", ""];
          case 5:
            return ["a3-card5", ""];
          case 6:
            return ["a3-card6", ""];
          default:
            return [];
        }
      } else {
        switch (this.pathstep.groupNum) {
          case 1:
            switch (this.pathstep.actNum) {
              case 6:
                return ["a3-card-g6", ""];
              default:
                return [];
            }
          case 2:
            switch (this.pathstep.actNum) {
              case 4:
                if (this.isEnvironmentPc()) {
                  return ["a3-card-g2", "card-col2p"];
                }
                return ["a3-card4", "card-col4p"];
              case 6:
                return ["a3-card-g2", "card-col3p"];
              default:
                return [];
            }
          case 3:
            switch (this.pathstep.actNum) {
              case 6:
                return ["a3-card-g3", "card-col2p"];
              default:
                return [];
            }
          default:
            return [];
        }
      }
    }
  },
  components: {
    A3act,
    PinchInImg
  },
  methods: {
    /**
    /* 初期化処理
     */
    init: function() {
      this.log("A3 start init");

      const self = this;

      store.commit({ type: "changeQuestionState", val: "start" });
      this.isSelect = true;

      this.items = this.getItems();
      this.setGroupIndexList(this.items);
    },
    /**
     * レイアウトに合わせたindex配列を生成する
     */
    setGroupIndexList: function(items) {
      this.actGroupIndexList = [];
      const self = this;

      return new Promise(function(resolve, rejct) {
        if (self.pathstep.groupNum == 0) {
          // グループなしの場合
          self.actGroupIndexList = [items];
        } else {
          // グループありの場合
          if(self.isEnvironmentPc()) {
            self.actGroupIndexList = items;
          } else {
            if(self.pathstep.layoutID == 24) {
              // グループを1つにする
              var list = [];
              items.forEach(function(item) {
                item.forEach(function(act) {
                  list.push(act);
                })
              });
              self.actGroupIndexList = [list];
            } else {
              self.actGroupIndexList = items;
            }
          }
        }
        resolve();
      });
    },
    /**
    /* 出題問題を取得する
     */
    question: function() {
      this.log("A3 start question");

      this.currentData = this.getQuestionRandom(this.correctIndex);

      // 画像選択可能にする
      this.isSelect = true;
    },
    /**
     * 画像選択時の処理
     */
    clickItem: function(A3act, index) {
      this.log("A3 start clickItem");

      const self = this;

      if (A3act.basicText == this.currentData.basicText) {
        // 正解の場合
        this.correctIndex.push(index);

        if (this.isAllCorrect(this.correctIndex.length)) {
          // 全問正解している場合

          // 全actの正解画像を表示する
          store.commit({ type: "changeQuestionState", val: "end" });

          // 問題出題中は次のpathstepに遷移しない
          if (this.lessonState == storeConstants.LESSON_STATE_PAUSE) {
            return;
          }

          // 親（Runmode.Vue）に通知する
          this.allCorrectTimer = setTimeout(function() {
            self.$emit("endAct");
          }, constants.ALLCORRECT_INTERVAL);
        } else {
          // 全問正解していない場合

          // isActStateの初期化
          this.isActState = true;
          // 次の問題へ
          this.question();
        }
      }
    },
    /**
     * 子(A3act）で正解した場合の処理
     */
    childIsCorrect: function() {
      // 画像選択を不可にする
      this.isSelect = false;

      // スコアを登録する
      this.setActState(this.isActState);
    },
    /**
     * 子(A3act）で不正解した場合の処理
     */
    childIsInCorrect: function() {
      // スコアの値を不正解にする
      this.isActState = false;
    },
    /**
     * カード領域自動サイズ調整処理
     */
    autoAdjustCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let clones = {};
      const cloneCard = function(targetText) {
        // カードを複製
        clones.card = $(".card-inner:first > .item:first").clone();
        clones.textArea = clones.card.children("div").children(".item-inner").children(".word");
        clones.text = clones.textArea.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        clones.text.html(targetText);
        clones.card.appendTo(".card-inner:first");
      };

      // サイズを確定させる
      this.fixCardAreaSize(cloneCard, clones);
    },
    /**
     * カード領域サイズ適用
     */
    applyCardAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // サイズ取得
      let fixedSize = this.getAutoAdjustFixedSize();
      let fixedHeight = fixedSize.cardAreaHeight;
      let fixedFontSize = fixedSize.cardAreaFontSize;
      // 確定した高さとフォントサイズを設定
      let textArea = $(".card-inner > .item > div > .item-inner > .word");
      textArea.height(fixedHeight);
      textArea.css({ fontSize: fixedFontSize });
    },
    /**
     * 長押しイベント開始
     *
     * @param String imgpath 画像パス
     */
    onTouchStart: function(imgpath) {
      this.log("A3 start TouchEvent::" + imgpath);
      if (this.isEnvironmentPc()) {
        // PCの場合は表示しない
        return;
      }
      var self = this;

      this.touchTimer = setTimeout(function() {
        self.showPinchInImage(imgpath);
      }, constants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      this.log("A3 end TouchEvent");
      clearTimeout(this.touchTimer);
    }
  },
  mounted: function() {
    this.init();
    this.question();

    // 自動調整初期処理
    this.initAutoAdjust([".page-content"], [".cards-container"]);
  },
  watch: {
    /**
     * ツールバー「日本語翻訳を表示する」の選択状態を監視する
     */
    dispJapaneseStatus: function(newstatus) {
      this.log("A3 watch dispJapaneseStatus");

      if (this.dispJapaneseStatus == false) {
        if (this.dispAllAnswerStatus == false) {
          this.applyCardAreaSize();
          this.isSelect = true;
        }
      } else {
        this.applyCardAreaSize();
        this.isSelect = false;
      }
    },
    /**
     * ツールバー「全解答を表示する」の選択状態を監視する
     */
    dispAllAnswerStatus: function(newstatus) {
      this.log("A3 watch dispAllAnswerStatus");

      if (this.dispAllAnswerStatus == false) {
        if (this.dispJapaneseStatus == false) {
          this.applyCardAreaSize();
          this.isSelect = true;
        }
      } else {
        this.applyCardAreaSize();
        this.isSelect = false;
      }
    },
    /**
     * スコア表示状態を監視する
     */
    lessonState: function(nesstatus) {
      this.log("A3 watch lessonState::"+nesstatus);

      const self = this;

      if (this.lessonState == storeConstants.LESSON_STATE_STOP) {
        this.$emit("stopAct");
      } else if (this.lessonState == storeConstants.LESSON_STATE_PAUSE) {
        if (this.allCorrectTimer != null) {
          clearTimeout(this.allCorrectTimer);
        }
      } else if (this.lessonState == storeConstants.LESSON_STATE_RESTART) {
        // リスタート時、全問正解している場合は次のpathstepに遷移する。
        if (this.isAllCorrect(this.correctIndex.length)) {
          // 親（Runmode.Vue）に通知する
          this.setInterval(constants.ALLCORRECT_INTERVAL).then(function() {
            self.$emit("endAct");
          });
        }
      }

      if (!this.isEnvironmentPc()) {
        // 表示領域自動調整
        let funcs = [this.autoAdjustCardArea, this.applyCardAreaSize];
        this.autoAdjustFirstShown(funcs, [".cards-container"]);
        // スクロールアイコン表示
        this.$emit("showScrollIcon", document.getElementsByClassName("cards-container")[0]);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/card";
</style>



// WEBPACK FOOTER //
// A3.vue?1aeaec2a